import classNames from 'classnames';
import React from 'react';

import css from './IconVineyard.module.css';

const IconVineyard = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 85 85"
    >
      <g fill="none" stroke="#011602" strokeMiterlimit="10" strokeWidth="2.5">
        <path d="M32.517 19.208h5.688M40.271 81.832H23.216a3.08 3.08 0 0 1-3.071-3.07V37.805c0-5.388 3.166-10.043 7.679-12.133V5.727a2.568 2.568 0 0 1 2.56-2.56h5.461a2.567 2.567 0 0 1 2.56 2.56v19.945c3.323 1.539 5.917 4.472 7.053 8.064" />
        <path strokeLinejoin="round" d="M20.229 42.148h15.128v24.055H20.229" />
        <g strokeLinejoin="round">
          <path
            d="M53.184 81.531V64.666M44.873 81.832h16.574M64.811 52.391l-1.396-13.792h-20.46l-1.399 13.792c-.608 6.836 5.194 12.148 11.628 12.148 6.431 0 12.236-5.312 11.627-12.148z"
            strokeLinecap="round"
          />
          <path d="M46.736 48.221h17.282" />
        </g>
      </g>
    </svg>
  );
};

export default IconVineyard;
